import React from 'react';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import * as S from './styles';
import Score from './components/Score';
import images from '~/constants/images';

export default function Information() {
  const { t } = useTranslation();
  const { data: match } = useSelector(state => state.matches.selectedMatch);
  const homeScore = match ? match.homeScore : '-';
  const awayScore = match ? match.awayScore : '-';

  return (
    <S.Container>
      <S.Header>
        {match && match.competitionLogo ? (
          <S.Logo url={match.competitionLogo} />
        ) : (
          <S.LogoDefault src={images.logoLaligaSantanderBlack} alt="alt" />
        )}
        <S.ScoreContainer>
          <Score
            homeTeamName={match ? match.homeTeam.nickname : ``}
            awayTeamName={match ? match.awayTeam.nickname : ``}
            homeTeamShield={match ? match.homeTeam.shieldImageUrl : ''}
            awayTeamShield={match ? match.awayTeam.shieldImageUrl : ``}
            homeTeamScore={
              homeScore || homeScore === 0 ? homeScore.toString() : '-'
            }
            awayTeamScore={
              awayScore || awayScore === 0 ? awayScore.toString() : '-'
            }
          />
        </S.ScoreContainer>
      </S.Header>
      <S.Content>
        <S.InfoList>
          <S.InfoItemRound
            icon="stopwatchWithBall"
            value={[
              {
                text: match ? match.gameweek.week : '-',
                label: t('round'),
              },
            ]}
          />
          <S.InfoItemDate
            icon="calendar"
            value={[
              {
                text: match ? format(new Date(match.date), 'd MMM') : `-- ---`,
                label: match ? format(new Date(match.date), 'YYY') : `----`,
              },
            ]}
          />
          <S.InfoItemTime
            icon="stopwatch"
            value={[
              {
                text: match
                  ? `${match.localTime ? match.localTime : '-'}`
                  : '--:--',
                label: t('local'),
              },
              {
                text: match
                  ? `${match.peninsulaTime ? match.peninsulaTime : '-'}`
                  : `--:--`,
                label: t('peninsular'),
              },
            ]}
          />
          <S.InfoItemStadium
            icon="field"
            value={[
              {
                text: match ? `${match.venue ? match.venue.name : '-'}` : ``,
                label: t('stadium'),
              },
            ]}
          />
          <S.InfoItemWeather
            icon="weather"
            value={[
              {
                text: match
                  ? `${
                      match.matchGrass
                        ? `${
                            match.matchGrass.weatherForecastRainfall
                              ? match.matchGrass.weatherForecastRainfall
                              : '-'
                          }`
                        : '-'
                    } mm/m2`
                  : '-',
                label: t('rainfall'),
              },
            ]}
          />
          <S.InfoItemHumidity
            icon="humidity"
            value={[
              {
                text: match
                  ? `${
                      match.matchGrass
                        ? `${
                            match.matchGrass.weatherForecastHumidity
                              ? match.matchGrass.weatherForecastHumidity
                              : '-'
                          }`
                        : '-'
                    } %`
                  : '-' /* falta humedad en EP /matches/{id} */,
                label: t('humidity'),
              },
            ]}
          />
          <S.InfoItemTemperature
            icon="temperature"
            value={[
              {
                text: match
                  ? `${
                      match.matchGrass
                        ? `${
                            match.matchGrass.weatherForecastTemperature
                              ? match.matchGrass.weatherForecastTemperature
                              : '-'
                          }`
                        : '-'
                    } °C`
                  : '-' /* falta temperatura en /matches/{id} */,
                label: t('temperature'),
              },
            ]}
          />
        </S.InfoList>
      </S.Content>
    </S.Container>
  );
}
